import * as React from "react";
import styled from "styled-components";

interface BreadcrumbsBlockProps {
  breadcrumbsElement: BreadcrumbsElementData
}

const BreadcrumbsBlock = (props: BreadcrumbsBlockProps) => {
  const {breadcrumbsElement} = props;
  const {elementName,elementDescription} = breadcrumbsElement;
  return (
    <div className="materialize-theme-styles">
      <BreadcrumbsPositionFixer/>
      <BreadcrumbsContainer className="page-title page-title-center ptb-50">
        <div className="container">
          <h2 className="text-bold white-text font-40">{elementName}</h2>
          <BreadcrumbDescription className="breadcrumb">{elementDescription}</BreadcrumbDescription>
        </div>
      </BreadcrumbsContainer>
    </div>
  )
};

/** STYLES */

const BreadcrumbsPositionFixer = styled.div`
  background: #03a9f4;
`;

const BreadcrumbsContainer = styled.section`
  background: #03a9f4 !important;
`;

const BreadcrumbDescription = styled.p`
  color: white;
  font-weight: bold;
  font-size: 13px;
 
`;

export default BreadcrumbsBlock


// WEBPACK FOOTER //
// ./src/layouts/breadcrumbs-block/breadcrumbs-block.tsx